﻿module PortalLibs.Shared.FileUtil

open System

let invalidFileNameChars =
  [| '#'
     '"'
     '*'
     '<'
     '>'
     '?'
     '\\'
     '|'
     '/'
     ':' |]

let cleanupFileName (fileName: string) =
  String
    .Concat(fileName.Split(invalidFileNameChars))
    .Trim()
